namespace Vit.Administration {
    export interface UserTenantRoleListResponse extends Serenity.ListResponse<number> {
    }
}